import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from '../message.service';
import { CreateAppointmentRequest, CreateAppointmentResult } from './create.appointment.request';
import { AppointmentDate } from '../shared/appointment-date';
import { AppointmentTime } from './appointmentTime';
import { IsAppointmentConfirmed } from './IsAppointmentConfirmed';
import { AddAppointmentRequest, AddAppointmentResult } from '../add-appointment/add-appointment.request';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  private AppointMentUrl = 'api/appointment';  // URL to web api
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private messageService: MessageService
  ) { }

  createAppointment(appointment: CreateAppointmentRequest): Observable<CreateAppointmentResult> {
    return this.http.post<CreateAppointmentResult>(this.AppointMentUrl, appointment, this.httpOptions).pipe(
      tap((result => this.messageService.log(`added Appointment w/ ${result}`)),
      error => catchError(this.messageService.handleError('createAppointment', error))
    ))};

  addAppointment(appointment: AddAppointmentRequest): Observable<AddAppointmentResult> {
      return this.http.put<AddAppointmentResult>(this.AppointMentUrl, appointment, this.httpOptions).pipe(
        tap((result => this.messageService.log(`added Appointment w/ ${result}`)),
        error => catchError(this.messageService.handleError('addAppointment', error))
      ))};

  getAvailableDates(hairdresser:string, service:string, extra: boolean): Observable<AppointmentDate[]>{
    return this.http.get<AppointmentDate[]>(
      `${this.AppointMentUrl}/availabledates?hairdresser=${hairdresser}&service=${service}&extra=${extra}`)
      .pipe(catchError(this.messageService.handleError('getAvailableDates', [])))
  }

  getAvailableAppointmentTimes(date:AppointmentDate, service:string, hairdresser:string, extra: boolean): Observable<AppointmentTime[]> {
    return this.http.get<AppointmentTime[]>(
      `${this.AppointMentUrl}/availabletimes?day=${date.day}&month=${date.month}&year=${date.year}&service=${service}&hairdresser=${hairdresser}&extra=${extra}`).pipe(
        map(result => {
          let response : AppointmentTime[] = result;
          return response.map(t => new AppointmentTime(t.hour, t.minutes))}),
        catchError(this.messageService.handleError('getAvailableAppointmentTimes', [])))
  }

  getAppointmentConfirmation(appointmentId:string): Observable<IsAppointmentConfirmed> {
    return this.http.get<IsAppointmentConfirmed>(`api/confirmation/confirmedappointments/${appointmentId}`);
  }

}
